"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Footer = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _stylers = _interopRequireDefault(require("@paprika/stylers"));

var _tokens = _interopRequireDefault(require("@paprika/tokens/lib/tokens"));

var compactStyles = (0, _styledComponents.css)(["padding:", ";"], _stylers["default"].spacer(2));

var Footer = _styledComponents["default"].div.withConfig({
  displayName: "Footerstyles__Footer",
  componentId: "sc-1ap4cog-0"
})(function (_ref) {
  var height = _ref.height,
      isCompact = _ref.isCompact;
  return (0, _styledComponents.css)(["align-items:center;background:", ";box-sizing:border-box;display:flex;flex-shrink:0;height:", ";padding:", " ", ";position:relative;transition:opacity 0.3s ease-in;width:100%;", ""], _tokens["default"].color.blackLighten80, height ? "".concat(height, "px") : _stylers["default"].spacer(9), _stylers["default"].spacer(2), _stylers["default"].spacer(3), isCompact ? compactStyles : "");
});

exports.Footer = Footer;
//# sourceMappingURL=Footer.styles.js.map